export function formatToNaturalNumber(n?: number | string) {
    if (!n || isNaN(~~n)) {
        return 0;
    }

    return ~~(n < 0 ? 0 : n);
}
